export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-operation-modal/index.js